import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-raisoni-mandi',
  templateUrl: './raisoni-mandi.component.html',
  styleUrls: ['./raisoni-mandi.component.scss']
})
export class RaisoniMandiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
